// import React, { useState, useEffect } from "react";
// import "./form.css";

// const VarshikShillakForm = ({ funds, banks }) => {
//   const [type, setType] = useState("HAT"); // HAT | BANK

//   const [formData, setFormData] = useState({
//     year: "2025-2026",
//     date: "",
//     fundName: "",
//     bankName: "",
//     accountNo: "",
//     amount: "",
//   });

//   const [records, setRecords] = useState(() => {
//     const savedRecords = localStorage.getItem("grampanchayat_varshik_shilak");
//     return savedRecords ? JSON.parse(savedRecords) : [];
//   });

//   // Save records to localStorage
//   useEffect(() => {
//     localStorage.setItem(
//       "grampanchayat_varshik_shilak",
//       JSON.stringify(records)
//     );
//   }, [records]);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!formData.amount || !formData.fundName || !formData.date) {
//       alert("❌ शिल्लक रक्कम, फंड नाव व दिनांक आवश्यक आहे!");
//       return;
//     }

//     if (type === "BANK" && (!formData.bankName || !formData.accountNo)) {
//       alert("❌ बँक नाव व खाते क्रमांक आवश्यक आहे!");
//       return;
//     }

//     setRecords([...records, { ...formData, type, id: Date.now() }]);

//     setFormData({
//       year: "2025-2026",
//       date: "",
//       fundName: "",
//       bankName: "",
//       accountNo: "",
//       amount: "",
//     });

//     alert("✅ शिल्लक माहिती यशस्वीरित्या जोडली गेली!");
//   };

//   const deleteRecord = (id) => {
//     const updated = records.filter((record) => record.id !== id);
//     setRecords(updated);
//   };

//   return (
//     <div className="varshik-container">
//       <div className="varshik-header">
//         <h3 className="varshik-title">📊 वर्षाची शिल्लक माहिती</h3>
//       </div>

//       {/* Radio */}
//       <div className="varshik-radio-row">
//         <label className="varshik-radio-label">
//           <input
//             type="radio"
//             checked={type === "HAT"}
//             onChange={() => setType("HAT")}
//           />
//           <span>🤚 हात शिल्लक</span>
//         </label>

//         <label className="varshik-radio-label">
//           <input
//             type="radio"
//             checked={type === "BANK"}
//             onChange={() => setType("BANK")}
//           />
//           <span>🏦 बँक शिल्लक</span>
//         </label>
//       </div>

//       {/* Form */}
//       <form onSubmit={handleSubmit} className="varshik-form-grid">
//         <div className="varshik-field">
//           <label>आर्थिक वर्ष*</label>
//           <input value={formData.year} disabled className="varshik-input" />
//         </div>

//         <div className="varshik-field">
//           <label>दिनांक*</label>
//           <input
//             type="date"
//             name="date"
//             value={formData.date}
//             onChange={handleChange}
//             className="varshik-input"
//             required
//           />
//         </div>

//         <div className="varshik-field">
//           <label>फंडाचे नाव*</label>
//           <select
//             name="fundName"
//             value={formData.fundName}
//             onChange={handleChange}
//             className="varshik-input"
//             required
//           >
//             <option value="">-- निधि निवडा --</option>
//             {funds.map((fund) => (
//               <option key={fund} value={fund}>
//                 {fund}
//               </option>
//             ))}
//           </select>
//         </div>

//         {type === "BANK" && (
//           <>
//             <div className="varshik-field">
//               <label>बँकेचे नाव*</label>
//               <select
//                 name="bankName"
//                 value={formData.bankName}
//                 onChange={handleChange}
//                 className="varshik-input"
//                 required
//               >
//                 <option value="">-- बँक निवडा --</option>
//                 {banks.map((bank) => (
//                   <option key={bank.id} value={bank.bankName}>
//                     {bank.bankName}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="varshik-field">
//               <label>बँक खाते क्रमांक*</label>
//               <input
//                 name="accountNo"
//                 value={formData.accountNo}
//                 onChange={handleChange}
//                 className="varshik-input"
//                 placeholder="खाते क्रमांक"
//                 required
//               />
//             </div>
//           </>
//         )}

//         <div className="varshik-field">
//           <label>शिल्लक रक्कम (₹)*</label>
//           <input
//             type="number"
//             name="amount"
//             value={formData.amount}
//             onChange={handleChange}
//             className="varshik-input"
//             placeholder="रक्कम"
//             step="0.01"
//             required
//           />
//         </div>

//         <div className="varshik-field varshik-full">
//           <button type="submit" className="varshik-btn-save">
//             💾 जतन करा
//           </button>
//         </div>
//       </form>

//       {/* Table */}
//       <div className="varshik-table-section">
//         <h4 className="varshik-table-title">📋 वर्षाची शिल्लक यादी</h4>

//         <div className="varshik-table-wrapper">
//           <table className="varshik-table">
//             <thead>
//               <tr>
//                 <th>क्र.</th>
//                 <th>प्रकार</th>
//                 <th>वर्ष</th>
//                 <th>फंड</th>
//                 <th>बँक</th>
//                 <th>खाते</th>
//                 <th>रक्कम</th>
//                 <th>दिनांक</th>
//                 <th>क्रिया</th>
//               </tr>
//             </thead>
//             <tbody>
//               {records.length === 0 ? (
//                 <tr>
//                   <td colSpan="9" className="varshik-no-data">
//                     📭 कोणतीही शिल्लक नोंद उपलब्ध नाही
//                   </td>
//                 </tr>
//               ) : (
//                 records.map((r, index) => (
//                   <tr key={r.id}>
//                     <td>{index + 1}</td>
//                     <td>
//                       <span className="varshik-badge">
//                         {r.type === "HAT" ? "🤚 हात" : "🏦 बँक"}
//                       </span>
//                     </td>
//                     <td>{r.year}</td>
//                     <td>{r.fundName}</td>
//                     <td>{r.bankName || "-"}</td>
//                     <td>{r.accountNo || "-"}</td>
//                     <td className="varshik-amount">
//                       ₹ {parseFloat(r.amount).toLocaleString("en-IN", {
//                         minimumFractionDigits: 2,
//                         maximumFractionDigits: 2,
//                       })}
//                     </td>
//                     <td>{r.date}</td>
//                     <td>
//                       <button
//                         onClick={() => deleteRecord(r.id)}
//                         className="varshik-btn-delete"
//                       >
//                         🗑️
//                       </button>
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default VarshikShillakForm;






import React, { useState, useEffect } from "react";
import "./form.css";

const VarshikShillakForm = ({ funds = [], banks = [] }) => {
  const [type, setType] = useState("HAT"); // HAT | BANK

  const [formData, setFormData] = useState({
    year: "2025-2026",
    date: "",
    fundName: "",
    bankName: "",
    accountNo: "",
    amount: "",
  });

  const [records, setRecords] = useState(() => {
    const savedRecords = localStorage.getItem("grampanchayat_varshik_shilak");
    return savedRecords ? JSON.parse(savedRecords) : [];
  });

  // Save records to localStorage
  useEffect(() => {
    localStorage.setItem(
      "grampanchayat_varshik_shilak",
      JSON.stringify(records)
    );
  }, [records]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.amount || !formData.fundName || !formData.date) {
      alert("❌ शिल्लक रक्कम, फंड नाव व दिनांक आवश्यक आहे!");
      return;
    }

    if (type === "BANK" && (!formData.bankName || !formData.accountNo)) {
      alert("❌ बँक नाव व खाते क्रमांक आवश्यक आहे!");
      return;
    }

    setRecords([...records, { ...formData, type, id: Date.now() }]);

    setFormData({
      year: "2025-2026",
      date: "",
      fundName: "",
      bankName: "",
      accountNo: "",
      amount: "",
    });

    alert("✅ शिल्लक माहिती यशस्वीरित्या जोडली गेली!");
  };

  const deleteRecord = (id) => {
    const updated = records.filter((record) => record.id !== id);
    setRecords(updated);
  };

  return (
    <div className="varshik-container">
      <div className="varshik-header">
        <h3 className="varshik-title">📊 वर्षाची शिल्लक माहिती</h3>
      </div>

      {/* Radio */}
      <div className="varshik-radio-row">
        <label className="varshik-radio-label">
          <input
            type="radio"
            checked={type === "HAT"}
            onChange={() => setType("HAT")}
          />
          <span>🤚 हात शिल्लक</span>
        </label>

        <label className="varshik-radio-label">
          <input
            type="radio"
            checked={type === "BANK"}
            onChange={() => setType("BANK")}
          />
          <span>🏦 बँक शिल्लक</span>
        </label>
      </div>

      {/* Form */}
      <form onSubmit={handleSubmit} className="varshik-form-grid">
        <div className="varshik-field">
          <label>आर्थिक वर्ष*</label>
          <input value={formData.year} disabled className="varshik-input" />
        </div>

        <div className="varshik-field">
          <label>दिनांक*</label>
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            className="varshik-input"
            required
          />
        </div>

        <div className="varshik-field">
          <label>फंडाचे नाव*</label>
          <select
            name="fundName"
            value={formData.fundName}
            onChange={handleChange}
            className="varshik-input"
            required
          >
            <option value="">-- निधि निवडा --</option>
            {Array.isArray(funds) && funds.map((fund) => (
              <option key={fund} value={fund}>
                {fund}
              </option>
            ))}
          </select>
        </div>

        {type === "BANK" && (
          <>
            <div className="varshik-field">
              <label>बँकेचे नाव*</label>
              <select
                name="bankName"
                value={formData.bankName}
                onChange={handleChange}
                className="varshik-input"
                required
              >
                <option value="">-- बँक निवडा --</option>
                {Array.isArray(banks) && banks.map((bank) => (
                  <option key={bank.id || bank.bankName} value={bank.bankName}>
                    {bank.bankName}
                  </option>
                ))}
              </select>
            </div>

            <div className="varshik-field">
              <label>बँक खाते क्रमांक*</label>
              <input
                name="accountNo"
                value={formData.accountNo}
                onChange={handleChange}
                className="varshik-input"
                placeholder="खाते क्रमांक"
                required
              />
            </div>
          </>
        )}

        <div className="varshik-field">
          <label>शिल्लक रक्कम (₹)*</label>
          <input
            type="number"
            name="amount"
            value={formData.amount}
            onChange={handleChange}
            className="varshik-input"
            placeholder="रक्कम"
            step="0.01"
            required
          />
        </div>

        <div className="varshik-field varshik-full">
          <button type="submit" className="varshik-btn-save">
            💾 जतन करा
          </button>
        </div>
      </form>

      {/* Table */}
      <div className="varshik-table-section">
        <h4 className="varshik-table-title">📋 वर्षाची शिल्लक यादी</h4>

        <div className="varshik-table-wrapper">
          <table className="varshik-table">
            <thead>
              <tr>
                <th>क्र.</th>
                <th>प्रकार</th>
                <th>वर्ष</th>
                <th>फंड</th>
                <th>बँक</th>
                <th>खाते</th>
                <th>रक्कम</th>
                <th>दिनांक</th>
                <th>क्रिया</th>
              </tr>
            </thead>
            <tbody>
              {records.length === 0 ? (
                <tr>
                  <td colSpan="9" className="varshik-no-data">
                    📭 कोणतीही शिल्लक नोंद उपलब्ध नाही
                  </td>
                </tr>
              ) : (
                records.map((r, index) => (
                  <tr key={r.id}>
                    <td>{index + 1}</td>
                    <td>
                      <span className="varshik-badge">
                        {r.type === "HAT" ? "🤚 हात" : "🏦 बँक"}
                      </span>
                    </td>
                    <td>{r.year}</td>
                    <td>{r.fundName}</td>
                    <td>{r.bankName || "-"}</td>
                    <td>{r.accountNo || "-"}</td>
                    <td className="varshik-amount">
                      ₹ {parseFloat(r.amount).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td>{r.date}</td>
                    <td>
                      <button
                        onClick={() => deleteRecord(r.id)}
                        className="varshik-btn-delete"
                      >
                        🗑️
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

// Add default props for safety
VarshikShillakForm.defaultProps = {
  funds: ["General Fund", "Education Fund", "Health Fund", "Development Fund"],
  banks: [
    { id: 1, bankName: "State Bank of India" },
    { id: 2, bankName: "Bank of Maharashtra" },
    { id: 3, bankName: "HDFC Bank" },
    { id: 4, bankName: "ICICI Bank" }
  ]
};

export default VarshikShillakForm;